"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _kendoReactDropdowns = require("@progress/kendo-react-dropdowns");

var _kendoDataQuery = require("@progress/kendo-data-query");

var _kendoReactIntl = require("@progress/kendo-react-intl");

var _pl = _interopRequireDefault(require("./pl.json"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var propTypes = {
  label: _propTypes.default.string,
  value: _propTypes.default.any,
  onChange: _propTypes.default.func.isRequired,
  error: _propTypes.default.string,
  invalid: _propTypes.default.bool,
  placeholder: _propTypes.default.string,
  items: _propTypes.default.array.isRequired
};
var defaultProps = {
  label: '',
  error: undefined,
  invalid: false,
  placeholder: undefined,
  value: []
};
var timeout;

function filterData(filter, allData) {
  var data = allData.slice();
  return (0, _kendoDataQuery.filterBy)(data, filter);
}

function FoxMultiSelect(_ref) {
  var label = _ref.label,
      value = _ref.value,
      onChange = _ref.onChange,
      error = _ref.error,
      invalid = _ref.invalid,
      placeholder = _ref.placeholder,
      items = _ref.items;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  (0, _react.useEffect)(function () {
    var df = items.slice();
    setData(df);
  }, [items]);

  var filterChange = function filterChange(event) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      var fd = filterData(event.filter, items);
      setData(fd);
      setLoading(false);
    }, 200);
    setLoading(true);
  };

  (0, _kendoReactIntl.loadMessages)(_pl.default, 'pl-PL');
  return _react.default.createElement(_kendoReactIntl.LocalizationProvider, {
    language: "pl-PL"
  }, _react.default.createElement(_kendoReactIntl.IntlProvider, {
    locale: "pl"
  }, _react.default.createElement(_kendoReactDropdowns.MultiSelect, {
    placeholder: placeholder,
    label: label,
    value: value,
    onChange: onChange,
    validationMessage: error,
    valid: !invalid,
    data: data,
    textField: "name",
    dataItemKey: "id",
    filterable: true,
    onFilterChange: filterChange,
    loading: loading
  })));
}

FoxMultiSelect.propTypes = propTypes;
FoxMultiSelect.defaultProps = defaultProps;
var _default = FoxMultiSelect;
exports.default = _default;